var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6665 13.7571C4.6665 7.62394 9.79168 2.66675 15.9911 2.66675C22.208 2.66675 27.3332 7.62394 27.3332 13.7571C27.3332 16.8477 26.2092 19.7169 24.3592 22.1488C22.3182 24.8314 19.8027 27.1687 16.9712 29.0033C16.3232 29.4273 15.7383 29.4593 15.0271 29.0033C12.1795 27.1687 9.66395 24.8314 7.6405 22.1488C5.78915 19.7169 4.6665 16.8477 4.6665 13.7571ZM12.2588 14.1024C12.2588 16.157 13.9354 17.773 15.9911 17.773C18.0482 17.773 19.7409 16.157 19.7409 14.1024C19.7409 12.0638 18.0482 10.3692 15.9911 10.3692C13.9354 10.3692 12.2588 12.0638 12.2588 14.1024Z",
    fill: "#767676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.870f63e120509ecbe13474567603ad19.svg";
export { ForwardRef as ReactComponent };